module.exports = __webpack_public_path__ + "img/dale_rafuse.aa28123d.jpg";